import moment from 'moment'
import _get from 'lodash/get'

import { FIELD_TYPE, REFDATA_MAP, DATE_FORMAT, CHOOSE_DATE } from '@/constants'

import { YES_NO  } from '@/applicationDefinition/droplistData/boolean'
import { YES_NO_DONOT } from '@/applicationDefinition/droplistData/booleanDontno'
import getHouseHold  from './helper/houseHoldDetails'
import getCounties from '../store/actions'




export default [
  {
    label: 'Housing Information',   
    type: FIELD_TYPE.HEADING
  }, 
  {
    apiKey: 'housing.noOfHouseHold',
    label: 'How many people are in the household not including yourself? This is everyone else who lives in your home other than you.',
    placeHolder: 'Enter Number of Household',
    maxLength: 3,    
    type: FIELD_TYPE.NUMBER,
    validation(value) {
      if (!/^[0-9]+$/.test(value)) {
        return `Can only contain numbers`
      }
    },
  }, 
  {
    label: 'Please list the people living in your home; include yourself, family, roommates, and/or anyone else that lives in your home',
    type: FIELD_TYPE.HEADING
  },
  getHouseHold('housing.houseHolds'),
  {
    apiKey: 'housing.homeless',
    label:'Are you currently homeless?',
    required: true,   
    type: FIELD_TYPE.RADIO,
    options: YES_NO
  },
  {
    type: FIELD_TYPE.HEADING,
    vHtmlLabel() {
      return `<strong>Current Address</strong>`
    },
    showLabel: true,
    showInReview: true,
    visible(application) {
      return application.housing.homeless  === false    
    }
  },
  {
    apiKey: `housing.currentAddress.street`,
    label: 'Street Address',
    placeHolder: 'Enter Street Address',
    required: true,
    visible(application) {
      return application.housing.homeless  === false    
    }
  },
  {
    apiKey: `housing.currentAddress.city`,
    label: 'City',
    placeHolder: 'Enter City',
    required: true,
    visible(application) {
      return application.housing.homeless  === false    
    }
  },
  {
    apiKey: `housing.currentAddress.state`,
    label: 'State / Province / Region',
    required: true,          
    placeHolder: 'Enter State',
    required: true,
    visible(application) {
      return application.housing.homeless  === false    
    }
  },
  {
    apiKey: `housing.currentAddress.zip`,
    label: 'ZIP / Postal Code',
    required: true,          
    placeHolder: 'Enter Zip Code',
    type: FIELD_TYPE.NUMBER,                
    required: true,
    visible(application) {
      return application.housing.homeless  === false    
    },
    onFieldSet(value, application, store){
      var counties= store.state.counties
        for (var key in counties) {
          if (counties.hasOwnProperty(key)) {
            if(counties[key].zip_code == value){
              store.commit('set', ['application.housing.currentAddress.county', counties[key].county])
              break
            }
        }
      }
    }
  },
  {
    apiKey: `housing.currentAddress.county`,
    label: 'County',
    maxLength: 100,   
    required: true,
    visible(application) {
      return application.housing.homeless  === false    
    }
  },
  {
    apiKey: `housing.currentAddress.howLong`,
    label: 'How long have you lived at this address?',
    placeHolder: 'Enter how long lived at the address',    
    maxLength: 100,
    required: true,
    visible(application) {
      return application.housing.homeless  === false    
    }
  },
  {
    apiKey: 'housing.currentAddress.faceEviction',
    label:'Are you currently facing an eviction?',
    required: true,
   // description:'household applied before',
    type: FIELD_TYPE.RADIO,
    options: YES_NO,
    visible(application) {
      return application.housing.homeless  === false    
    }
  },
  {
    apiKey: 'housing.currentAddress.courtDateSet',
    label:'Is there a court date set?',
    required: true,
   // description:'household applied before',
    type: FIELD_TYPE.RADIO,
    options: YES_NO,
    visible(application) {
      return application.housing.homeless  === false&&application.housing.currentAddress.faceEviction      
    }
  },
  {
    apiKey: `housing.currentAddress.courtDate`,
    label: 'Date of Court',
    required: true,
    type: FIELD_TYPE.DATE,
    visible(application) {
      return application.housing.homeless  === false&&application.housing.currentAddress.courtDateSet      
    }
  },
  {
    apiKey: 'housing.currentAddress.paymentPlan',
    label:'Is the landlord willing to work with you on a payment plan?',
    required: true,
   // description:'household applied before',
    type: FIELD_TYPE.RADIO,
    options: YES_NO_DONOT,
    visible(application) {
      return application.housing.homeless  === false&&application.housing.currentAddress.faceEviction      
    }
  },
  {
    apiKey: 'housing.currentAddress.utilityStatus',
    label:'Are any of your utilities shut off right now?',
    required: true,
   // description:'household applied before',
    type: FIELD_TYPE.RADIO,
    options: YES_NO,
    visible(application) {
      return application.housing.homeless  === false    
    }
  },
  {
    apiKey: 'housing.currentAddress.utilityShutOffNotice',
    label:'Is there a Shutoff notice for any of your utilities?',
    required: true,
   // description:'household applied before',
    type: FIELD_TYPE.RADIO,
    options: YES_NO,
    visible(application) {
      return application.housing.homeless  === false&&application.housing.currentAddress.utilityStatus  === false    
    }
  },
  {
    apiKey: `housing.currentAddress.shutOffDate`,
    label: 'Date of scheduled shutoff?',
    required: true,
    type: FIELD_TYPE.DATE,
    visible(application) {
      return application.housing.homeless  === false&&application.housing.currentAddress.utilityStatus  === false&&application.housing.currentAddress.utilityShutOffNotice      
    },
  },
]